module.exports = __webpack_public_path__ + "static/boundless-opportunity-dab303fded7ceb80f68042c1230d2031.jpg";